<template>
    <div class="settings__item data-card block" v-bind:style="cardStyle">
        <div class="data-card__head bank-card">
            <div class="bank-card__icon">
                <img v-bind:src="image" alt="">
            </div>
            <div class="bank-card__number">
                <span class="status-primary">{{number}}</span>
                <span class="bank-card__date-validity status-primary" style="font-weight: normal;">
                    Действует до:
                    <font v-bind:style="{color: dateColor}">{{datevalid}}</font>
                </span>
            </div>

            <div class="bank-card__icon">
                <img v-if="card.MerchId=='SB'" src="/images/pay-types/sberbank-icon.png" height="32" alt="">
                <img v-else src="/images/pay-types/gasprombank-icon.png" height="32" alt="">
            </div>

            <div class="bank-card__date">
                <span v-if="(card.MerchCode=='FL' || card.MerchCode=='SB')" class="bank-card__person">Оплата ЛС ФЛ</span>
                <span v-if="card.MerchCode=='23'" class="bank-card__person">Оплата ЛС ЮЛ</span>
                <span v-if="card.MerchCode=='120'" class="bank-card__person">Оплата ЛС ЮЛ Подсинее</span>
                <span v-if="card.MerchCode=='KZ'" class="bank-card__person">Оплата ЛС ФЛ Кыз.ТЭЦ</span>
                <span v-if="card.MerchCode=='72'" class="bank-card__person">Оплата ЛС ЮЛ Кыз.ТЭЦ</span>
                <span class="">Добавлена: <span class="status-primary">{{dateadd}}</span></span>
            </div>

            <!--Основные карты в двойном эквайринге не назначаются.-->
            <!--<div class="help bank-card__favorite">
                <div class="help__icon button-icon bank-card__favorite-icon button-icon--th-remove-light js-favorites-card-trigger" @click="setMain()" v-bind:style="iconStyle">
                    <svg width="18" height="17" viewBox="0 0 18 17" v-bind:fill="(card.IsDefault) ? '#0078a8' : '#f6f6f4'" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.26989 5.5284L8.34792 1.39771C8.61464 0.867431 9.38536 0.867431 9.65208 1.39771L11.7301 5.5284L16.3772 6.19487C16.9734 6.28038 17.211 6.99953 16.7794 7.41203L13.4174 10.6251L14.2108 15.1643C14.3127 15.7472 13.6891 16.1917 13.1556 15.9164L9 13.7721L4.84438 15.9164C4.31088 16.1917 3.68727 15.7472 3.78916 15.1643L4.5826 10.6251L1.2206 7.41203C0.788937 6.99953 1.02658 6.28038 1.62282 6.19487L6.26989 5.5284Z" v-bind:stroke="(card.IsDefault) ? 'white' : 'black'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </div>
                <div class="help__drop help__drop--md">
                    <div class="help__inner">Сделать основной картой</div>
                </div>
            </div>-->

            <div class="bank-card__remove">
                <div class="button-icon button-icon--th-remove-light" v-on:click="changeVisible"><i class="icon icon--remove"></i></div>
            </div>
        </div>
        <div class="b-form-sm__item" :style="{ display: visible }">
            <div>
                <a class="button button--th-second"
                   v-on:click="deleteCard">Удалить</a>
                <a v-on:click="changeVisible" class="button button--th-link" data-toggle="collapse">Отменить</a>
            </div>
            <span style="color: red">{{error}}</span>
        </div>
    </div>

</template>

<script>
    export default {
        props: ['card'],
        data: function () {
            return {
                ps: "",
                visible: "none",
                OnOff: "block",
                error: "",
                fillColor: '',
                dateColor: 'blue',
            }
        },
        methods: {
            setMain: function () {
                if (!this.card.IsDefault) {
                    var self = this;
                    axios.get('/Profiles/DefaultCard?id=' + this.card.Id)
                        .then(function (response) {
                            self.$emit('defaultCard', self.card);
                        })
                        .catch(function (error) {
                            console.log(error)
                            self.setError('Ошибка, попробуйте позже');
                        });
                }
            },
            setError: function (message) {
                this.error = message;
            },
            changeVisible: function () {
                if (this.visible == "none")
                    this.visible = "block";
                else {
                    this.visible = "none";
                    this.error = "";
                }
            },
            deleteCard: function () {
                var self = this;
                var cmd = '/Profiles/DeleteCard?merchCode=' + this.card.MerchCode + '&id=';
                if (this.card.MerchCode == 'SB')
                    cmd += this.card.CardId;
                else
                    cmd += this.card.Id;
                axios.delete(cmd)
                    .then(function (response) {
                        self.OnOff = "none";
                    })
                    .catch(function (error) {
                        console.log(error)
                        self.setError('Удаление карты невозможно, попробуйте позже');
                    });
            }
        },
        computed: {
            cardStyle: function () {
                return { display: this.OnOff };
            },
            iconStyle: function () {
                if (this.card.IsDefault)
                    return { backgroundColor: '#0078a8' };
                else
                    return { backgroundColor: '#f6f6f4' };
            },
            image: function () {
                this.ps = this.card.MaskName.substring(0, 1);
                if (this.ps === '2') return "/images/mir.png";
                else if (this.ps === '4') return "/images/visa.png"
                else if (this.ps === '5') return "/images/master.png";
                else if (this.ps === '6') return "/images/UnionPay.png";
                return "/images/other.png";
            },
            bank: function () {
                if (this.card.MerchCode == 'SB')
                    return "/images/bank/sber30.png";
                else
                    return "/images/bank/gpb30.png";
            },
            number: function () {
                var mask = this.card.MaskName
                if (mask.length === 16)
                    return mask.substring(0, 4) + ' ' + mask.substring(4, 8) + ' ' + mask.substring(8, 12) + ' ' + mask.substring(12);
                return mask;
            },
            //merch: function () {
            //    var m = this.card.MerchCode;
            //    if (m === 'FL') return 'физ. лиц';
            //    else if (m === 'SB') return 'физ. лиц';
            //    else if (m === 'KZ') return 'Кыз. ТЭЦ';
            //    return '';
            //},
            datevalid: function () {
                var year = Number('20' + this.card.ExpDate.substring(0, 2));
                var mounth = Number(this.card.ExpDate.substring(2, 4));
                if (new Date() > new Date(year, mounth, 0)) {
                    this.dateColor = 'red';
                    return this.card.ExpDate.substring(2, 4) + "/" + this.card.ExpDate.substring(0, 2);
                }
                if (new Date() < new Date(year, mounth - 6, 1)) {
                    this.dateColor = 'inherit';
                    return "xx/" + this.card.ExpDate.substring(0, 2);
                }
                this.dateColor = 'green';
                return this.card.ExpDate.substring(2, 4) + "/" + this.card.ExpDate.substring(0, 2);
            },
            dateadd: function () {
                //var date = this.card.Added.substring(3, 5) + "." + this.card.Added.substring(0, 2) + "." + this.card.Added.substring(6, 10);
                var date = this.card.Added.substring(0, 2) + "." + this.card.Added.substring(3,5) + "." + this.card.Added.substring(6, 10);
                return date;
            }
        }
    }

</script>


// WEBPACK FOOTER //
// Scripts/app/profiles/components/ViewCards.vue